/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { SortSourceAccountsBy } from '../models/SortSourceAccountsBy';
import { SourceAccountsFilterConditions } from '../models/SourceAccountsFilterConditions';

export class ListSourceAccountsRequest {
  'filters'?: SourceAccountsFilterConditions;
  'sorts'?: Array<SortSourceAccountsBy>;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "filters",
      "baseName": "filters",
      "type": "SourceAccountsFilterConditions",
      "format": ""
    },
    {
      "name": "sorts",
      "baseName": "sorts",
      "type": "Array<SortSourceAccountsBy>",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return ListSourceAccountsRequest.attributeTypeMap;
  }

  public constructor() {
  }
}

